const i = "Notification", t = "Notification critique", o = "Fermer la notification", c = {
  notification: i,
  criticalNotification: t,
  close: o
};
export {
  o as close,
  t as criticalNotification,
  c as default,
  i as notification
};
